import { createStyles, Dialog, makeStyles, Theme } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';

import { SlideTransitionLeft } from '../../shared/transitions/SlideTransitionLeft';
import { CloseConfirmation } from './CloseConfirmation';
import { useOnCloseWithConfirmation } from './useOnCloseWithConfirmation';

interface Props {
  open: boolean;
  onClose: () => void;
  shouldConfirmClose?: boolean;
  className?: string;
  children: React.ReactNode;
}

export const RightSideDialog = ({
  open,
  shouldConfirmClose,
  onClose,
  className,
  children,
}: Props): React.ReactElement => {
  const classes = useStyles();
  const { onCloseWithConfirmation, shouldShowConfirmation } = useOnCloseWithConfirmation({ onClose });

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={shouldConfirmClose ? onCloseWithConfirmation : onClose}
      TransitionComponent={SlideTransitionLeft}
      className={classNames(classes.drawerPaper, className)}
    >
      <CloseConfirmation shouldShowConfirmation={shouldShowConfirmation} />
      {children}
    </Dialog>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    drawerPaper: {
      minWidth: '700px',
      width: '65%',
      left: 'unset !important', // by default, full screen will set left: 0px, so we need to undo that
    },
  })
);
